import { Suspense } from 'react';
import { Outlet } from 'react-router';
import { ErrorPage } from '@/components/error-page/error-page.tsx';
import { Page, PageContent } from '@/components/layout/page.tsx';
import { MarketplaceHeader } from '@/routes/_app.p.marketplace/marketplace-header/marketplace-header.tsx';

export const ErrorBoundary = ErrorPage;

export default function Marketplace() {
  return (
    <Page>
      <PageContent>
        <MarketplaceHeader />

        <Suspense fallback={null}>
          <Outlet />
        </Suspense>
      </PageContent>
    </Page>
  );
}
